<template>
  <div class="form-container">
    <h3 class="text-center">enrol profile {{enrolProfile.enrolId}}</h3>
    <ConfirmedAction
        :entity-id="enrolProfile.enrolId"
        :skip-first-step="true"
        info-text="Do you want to delete this enrolment profile?"
        button-label="Delete enrol profile"
        button-icon="trash-alt"
        confirm-text="Please confirm you want to delete this enrol profile by typing its full id below. You can copy and paste it from the previous page."
        confirm-help="The enrol profile to delete"
        success-message=""
        error-message=""
        @action-confirmed="deleteItem()"
        @action-cancelled="cancel()"
      />
  
    <Error :label="error"/>
    <Success :label="success"/>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import Error from '@/components/Error.vue';
import Success from '@/components/Success.vue';
import ConfirmedAction from '@/components/ConfirmedAction.vue';
import { EnrolProfile } from '@/types';
import { ApiClient, curApiClient } from '@/services/ApiClient';

interface Props {
  enrolProfile: EnrolProfile;
}

const props = withDefaults(defineProps<Props>(), {
  enrolProfile: () => ({}) as EnrolProfile
});

const emit = defineEmits<{
  cancel: [];
}>();

const router = useRouter();

const error = ref<string>('');
const success = ref<string>('');

const apiClient: ApiClient = curApiClient;

const deleteItem = async () => {
  const reply = await apiClient.deleteEnrolProfile(props.enrolProfile.enrolId);
  
  if(reply.httpCode === 403)
    return router.push({name:'login'});

  if(reply.errorMsg)
    return error.value = `Unable to delete enrol profile: ${reply.errorMsg}`;
  
  setSuccess(`Enrol profile ${props.enrolProfile.enrolId} has been deleted`);
};

const setSuccess = (str: string) => {
  success.value = str;
  setTimeout(() => emit('cancel'), 1000);
};

const cancel = () => {
  emit('cancel');
};
</script>

<style scoped lang="scss">

</style>